import React from "react";
import { H, Spinner } from "../../components";

const UploadingScreen = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: "shadow-md w-full max-w-xl flex flex-col items-center bg-white rounded-lg py-8 px-4"
  }, /*#__PURE__*/React.createElement(H, {
    level: 3,
    as: "h2"
  }, "Uploading account info"), /*#__PURE__*/React.createElement("div", {
    className: "flex h-64 items-center justify-center"
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: "10rem",
    borderWidth: "7px",
    borderColor: "#FFD204"
  })));
};

export default UploadingScreen;